export default __webpack_public_path__ + "static/media/330_portfolio03-nl-web.c8859a93.png";